import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckboxItem } from '@boma/supplier-portal/shared/entities';

@Component({
  selector: 'boma-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss'],
})
export class CheckboxListComponent {
  @Input() items: CheckboxItem[] = [
    {
      value: 1,
      label: 'Value One',
      selected: false,
    },
    {
      value: 2,
      label: 'Value Two',
      selected: false,
    },
  ];
  @Input() settings: { style: string } = {
    style: 'button', // button,checkbox
  };
  @Output() updateSelection: EventEmitter<CheckboxItem[]> = new EventEmitter();
  selectedBoxes: CheckboxItem[];

  updateCheckBoxes() {
    this.selectedBoxes = this.items.filter((x) => x?.selected);

    //remove the all before emitting if exists

    this.updateSelection.emit(this.selectedBoxes);
  }
}
